import React, {FC} from 'react';

import {AppPanelId} from '../../../../libs/shared/core/src/store/panels/panelStateBase';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {useAppDispatch} from '../../../helpers/appReduxHelpers';
import {buildOpenSidebarPluginPath} from '../../../helpers/openSidebarPluginHelpers';
import {ApplicationInboxSidePanelEntryPointModel} from '../../../models/api/applicationEntryPointModel';
import {VoiceBannerState} from '../../../store/panels/app/banners/bannersState';
import {navigateToLinkAction} from '../../../store/stateless/navigationActions';
import {ApplicationIcon} from '../../common/applications/applicationIcon';
import {IncomingCallBanner} from './incomingCallBanner';

/*
 * Props.
 */

interface ApplicationIncomingCallBannerProps {
  panelId: AppPanelId;
  bannerState: VoiceBannerState;
  entryPoint: ApplicationInboxSidePanelEntryPointModel;
  contactName?: string;
}

export const ApplicationIncomingCallBanner: FC<ApplicationIncomingCallBannerProps> = (props) => {
  const {bannerState, entryPoint, contactName} = props;
  const dispatch = useAppDispatch();

  const onActionClick = () => {
    // Pin and select the P4 plugin, and navigate to the inboxes panel.
    const parameters = {frameId: entryPoint.frameId, options: {bannerId: bannerState.uid}};
    const link = buildOpenSidebarPluginPath(parameters);
    dispatch(navigateToLinkAction(link));
  };

  const openPluginText = `open ${entryPoint.name} plugin`;

  return (
    <IncomingCallBanner
      icon={renderAvatar(entryPoint)}
      onActionClick={onActionClick}
      actionText={openPluginText}
      contactName={contactName}
      contactHandle={bannerState.incomingCallContact?.handle ?? ''}
    />
  );
};

function renderAvatar(entryPoint: ApplicationInboxSidePanelEntryPointModel) {
  return <ApplicationIcon applicationId={entryPoint.applicationId} size={VisualSizesEnum.MEDIUM} />;
}
